window.addEventListener("load", () => {
    let label; 
    let bgColor = '#224697';
    
    const solid2 = document.getElementById("solid2")
    const pattern2 = document.getElementById("pattern2")
    const contrast2 = document.getElementById("contrast2")
    const melange2 = document.getElementById("melange2")
    const select2 = document.getElementById("select-style2")
    const title = document.getElementById("dtc-title-2").innerText

    
    if (title.indexOf('Patterns') !== -1) {
        label = 'Select Style: PATTERN'
        pattern2.style.backgroundColor = bgColor;
        pattern2.style.color = '#ffffff';

        solid2.addEventListener('click', () => {
            pattern2.style.backgroundColor = '#ffffff';
            pattern2.style.color = '#000000';
        })

    } else if(title.indexOf('Solids') !== -1) {
        label = 'Select Style: SOLID'
        solid2.style.backgroundColor = bgColor;
        solid2.style.color = '#ffffff';

        pattern2.addEventListener('click', () => {
            solid2.style.backgroundColor = '#ffffff';
            solid2.style.color = '#000000';
        })

    }

    else if (title.indexOf('Contrast') !== -1) {
        label = 'Select Style: CONTRAST'
        contrast2.style.backgroundColor = bgColor;
        contrast2.style.color = '#ffffff';
    
        
        pattern2.addEventListener('click', () => {
            contrast2.style.backgroundColor = '#ffffff';
            contrast2.style.color = '#000000';
          })
          
        solid2.addEventListener('click', () => {
            contrast2.style.backgroundColor = '#ffffff';
            contrast2.style.color = '#000000';
          })
    } 

  else if (title.indexOf('Melange') !== -1) {
        label = 'Select Style: MELANGE'
        melange2.style.backgroundColor = bgColor;
        melange2.style.color = '#ffffff';
    
        
        pattern2.addEventListener('click', () => {
            contrast2.style.backgroundColor = '#ffffff';
            contrast2.style.color = '#000000';
          })
          
        solid2.addEventListener('click', () => {
            contrast2.style.backgroundColor = '#ffffff';
            contrast2.style.color = '#000000';
          })
    }
    if (select2){
        select2.innerHTML = label
    }

    


})
